/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/destructuring-assignment */
import * as H from 'history'
import React from 'react'
import { ApplicationModel } from '../../models/ApplicationModel'
// import { FinancialYearModel } from '../../models/FinancialYearModel'
import { GUID } from '../../models/Guid'

export interface SubmissionPageProps {
    history: H.History
    model: ApplicationModel
    autoClaimNumber: string
    blobID : GUID
    // eslint-disable-next-line no-unused-vars
    onPrint: (event: React.MouseEvent) => any
    // currentApplicationPeriod: FinancialYearModel
}

export interface SubmissionPageState {
}

export class SubmissionPage extends React.Component<SubmissionPageProps, SubmissionPageState> {
  constructor(props: SubmissionPageProps) {
    super(props)
    this.state = {
    }
  }

  close = () => {
    this.props.history.push('/')
  }

  print = (e: React.MouseEvent) => {
    if (this.props.onPrint) this.props.onPrint(e)
    else window.print()
  }

  openFile = (applicationID: string, applicationBlobID: string) => {
    fetch(`/api/DocumentReform/download?applicationId=${applicationID}&blobid=${applicationBlobID}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/pdf' },
    })
      .then(res => res.blob())
      .then(response => {
        const file = new Blob([response], {
          type: 'application/pdf',
        })
        const fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error)
      })
  }

  render() {
    const { model, autoClaimNumber, blobID } = this.props

    return (
      <div>
        <h2 className="mt-3">Application confirmation</h2>
        <p>{`Your Application ID is : ${autoClaimNumber}`}</p>
        <p>Thank you for applying for Export Market Development Grant. Your application has been submitted.</p>

        <p>
          {'You can view your submitted application anytime in the Portal and you can also '}
          <a href="#" onClick={(e) => { e.preventDefault(); this.openFile(model.applicationID, blobID) }}>
            download your application as a PDF.
          </a>
        </p>

        <p>
          Your application will be assessed against the Program's eligibility criteria in order of application receipt and advise you of the outcome as soon as possible.&nbsp;
          You can log on to the portal to check the status of your application.&nbsp;
          If you are eligible, we will provide you with a grant agreement for you to accept via our portal.&nbsp;
          Grants will be awarded to eligible applicants in order of application receipt, until the funding is fully allocated for each tier.
        </p>
        <p>
          {'During the assessment process we may contact you to clarify information you have provided in your application. '
          + 'If you find an error in your application after submitting it, send an email immediately to '}
          <a href="mailto:EMDG.Help@austrade.gov.au">EMDG.Help@austrade.gov.au.</a>
          {' We may decide not to accept your application with the correction as it is your responsibility'
          + ' to ensure the application is complete and accurate prior to submission.'}
        </p>
        {/* <PrintBackButtons onBack={this.close} onPrint={this.print} backLabel="Close" printLabel={this.props.onPrint ? 'Print to pdf' : 'Print'} /> */}
      </div>
    )
  }
}
